

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareLetterboxPosition from "../DesignerQuestionHardwareLetterboxPosition.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareLetterboxPosition
        ],
        props: {
            title: {
                default(){
                    return 'Choose your Letterbox Position';
                }
            },
            component_id: {
                default(){
                    return 'hardware_letterbox_position';
                }
            },
            hardwareLetterbox: {
                required: true
            },
            slab: {
                required: true
            },
            sidePanels: {
                required: true
            },
            frameId: {
                required: true
            },
            frameMaterial: {
                required: true
            },
            doorRange: {
                default() {
                    return 0;
                }
            },
            decorativePosition: {
                default() {
                    return '';
                }
            }
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareLetterbox, this.sidePanels, this.frameId, this.frameMaterial, this.decorativePosition);
            },
            options_filter(){
                return this.filtered_option_list.length > 1;
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-position?category=7&slab=' + this.slab
                    + '&hardware_id=' + this.hardwareLetterbox
                    + '&left=' + this.left_panel
                    + '&right=' + this.right_panel
                    + '&left_composite_id=' + this.left_composite_id
                    + '&right_composite_id=' + this.right_composite_id
                    + '&frame_id=' + this.frameId
                    + '&frame_material=' + this.frameMaterial
                    + '&door_range=' + this.doorRange
                    + '&decorative_handle_position=' + this.decorativePosition;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareLetterbox + '_' + this.left_panel + '_' + this.right_panel + '_' + this.left_composite_id + '_' + this.right_composite_id + '_' + this.frameId + '_' + this.frameMaterial + '_' + this.doorRange + '_' + this.decorativePosition;
            },
            left_panel(){
                if (this.sidePanels.left === null) {
                    return 1;
                }
                return this.sidePanels.left;
            },
            right_panel(){
                if (this.sidePanels.right === null) {
                    return 1;
                }
                return this.sidePanels.right;
            },
            left_composite_id(){
                if (this.sidePanels.left_composite_id === null) {
                    return 31;
                }
                return this.sidePanels.left_composite_id;
            },
            right_composite_id(){
                if (this.sidePanels.right_composite_id === null) {
                    return 31;
                }
                return this.sidePanels.right_composite_id;
            },
        },
        watch: {
            'hardwareLetterbox': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'sidePanels': {
                handler: _.debounce(function (val, oldVal) {
                    this.update_options();
                }, 200),
                deep: true,
            },
            'frameId': function (val, oldVal) {
                this.update_options();
            },
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'decorativePosition': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
